jQuery(function ($) {
    const form = $('#center-modal-form');
    if (!form.length || form.data('form-version') !== 'v2') {
        return;
    }

    const submitBtn = form.find('input[type="submit"]');
    const preloader = form.find('.center-modal-form-preloader');
    const warningBox = $('.center-modal-form-warning-messages');

    const fieldMap = {
        name: {
            input: form.find('input[name="name"]'),
            inline: form.find('.center-modal-inline-error-name'),
            message: $('.center-modal-form-message-warning-name')
        },
        surname: {
            input: form.find('input[name="surname"]'),
            message: $('.center-modal-form-message-warning-surname')
        },
        code: {
            input: form.find('input[name="code"]'),
            message: $('.center-modal-form-message-warning-code')
        },
        email: {
            input: form.find('input[name="email"]'),
            inline: form.find('.center-modal-inline-error-email'),
            message: $('.center-modal-form-message-warning-email')
        },
        phone: {
            input: form.find('input[name="phone"]'),
            inline: form.find('.center-modal-inline-error-phone'),
            message: $('.center-modal-form-message-warning-phone')
        },
        income: {
            input: form.find('input[name="income"]'),
            message: $('.center-modal-form-message-warning-income')
        },
        workplace: {
            input: form.find('input[name="workplace"]'),
            message: $('.center-modal-form-message-warning-workplace')
        },
        work_experience: {
            input: form.find('input[name="work_experience"]'),
            message: $('.center-modal-form-message-warning-work-experience')
        },
        channel: {
            input: form.find('select[name="channel"]'),
            message: $('.center-modal-form-message-warning-channel')
        },
        privacy_policy: {
            input: form.find('input[name="privacy_policy"]'),
            message: $('.center-modal-form-message-warning-privacy-policy')
        }
    };

    let formRunning = false;

    function normalizePhone(value) {
        return String(value || '').replace(/\s+/g, '');
    }

    function lvPhoneDigits(value) {
        let d = String(value || '').replace(/\D+/g, '');
        if (d.startsWith('00')) d = d.slice(2);
        if (d.startsWith('371')) d = d.slice(3);
        return d.slice(0, 8);
    }

    function isValidLvPhone(value) {
        return lvPhoneDigits(value).length === 8;
    }

    function normalizePersonalCodeInput(el) {
        if (!el || !el.length) return;
        const d = String(el.val() || '').replace(/\D+/g, '').slice(0, 11);
        if (d.length > 6) {
            el.val(d.slice(0, 6) + '-' + d.slice(6));
        } else {
            el.val(d);
        }
    }

    function isPersonalCodeComplete(value) {
        return String(value || '').replace(/\D+/g, '').length === 11;
    }

    function parseIncome(value) {
        const n = parseFloat(String(value || '').replace(/\s/g, '').replace(',', '.'));
        return Number.isFinite(n) ? n : NaN;
    }

    function isValidName(value) {
        return String(value || '').trim().length >= 2;
    }

    function isValidEmail(value) {
        const v = String(value || '').trim();
        return v !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    function isValidWorkExperience(value) {
        const n = parseInt(String(value || '').replace(/\D/g, ''), 10);
        return Number.isFinite(n) && n >= 0 && n <= 600;
    }

    function updateSubmitState() {
        fieldMap.code.input.each(function () {
            normalizePersonalCodeInput($(this));
        });
        const valid = isValidName(fieldMap.name.input.val())
            && isValidName(fieldMap.surname.input.val())
            && isPersonalCodeComplete(fieldMap.code.input.val())
            && isValidEmail(fieldMap.email.input.val())
            && isValidLvPhone(fieldMap.phone.input.val())
            && Number.isFinite(parseIncome(fieldMap.income.input.val()))
            && parseIncome(fieldMap.income.input.val()) > 0
            && String(fieldMap.workplace.input.val() || '').trim().length >= 2
            && isValidWorkExperience(fieldMap.work_experience.input.val())
            && String(fieldMap.channel.input.val() || '').trim() !== ''
            && fieldMap.privacy_policy.input.is(':checked');
        submitBtn.prop('disabled', !valid);
        return valid;
    }

    function showInline(field, message) {
        if (field.inline && field.inline.length) {
            field.inline.text(message).removeClass('d-none');
        }
    }

    function hideInline(field) {
        if (field.inline && field.inline.length) {
            field.inline.text('').addClass('d-none');
        }
    }

    function clearWarnings() {
        warningBox.hide();
        Object.values(fieldMap).forEach(field => {
            if (field.input && field.input.length) {
                field.input.removeClass('input-warning');
            }
            if (field.message && field.message.length) {
                field.message.hide();
            }
            hideInline(field);
        });
    }

    function markFieldError(fieldName, message) {
        const field = fieldMap[fieldName];
        if (!field) return;

        if (field.input && field.input.length) {
            field.input.addClass('input-warning');
        }
        if (field.message && field.message.length) {
            field.message.text(message).show();
        }
        showInline(field, message);
    }

    const inlineMessages = {
        name: (fieldMap.name.message && fieldMap.name.message.text()) || 'Invalid name',
        email: (fieldMap.email.message && fieldMap.email.message.text()) || 'Invalid email',
        phone: (fieldMap.phone.message && fieldMap.phone.message.text()) || 'Invalid phone'
    };

    function validateAndShowInline() {
        const nameVal = fieldMap.name.input.val();
        const emailVal = fieldMap.email.input.val();
        const phoneVal = fieldMap.phone.input.val();

        if (fieldMap.name.input.data('touched')) {
            if (!isValidName(nameVal)) {
                showInline(fieldMap.name, inlineMessages.name);
            } else {
                hideInline(fieldMap.name);
            }
        }

        if (fieldMap.email.input.data('touched')) {
            if (!isValidEmail(emailVal)) {
                showInline(fieldMap.email, inlineMessages.email);
            } else {
                hideInline(fieldMap.email);
            }
        }

        if (fieldMap.phone.input.data('touched')) {
            if (!isValidLvPhone(phoneVal)) {
                showInline(fieldMap.phone, inlineMessages.phone);
            } else {
                hideInline(fieldMap.phone);
            }
        }
    }

    fieldMap.phone.input.on('input', function (e) {
        const v = normalizePhone(e.target.value);
        if (e.target.value !== v) {
            e.target.value = v;
        }
        updateSubmitState();
    });

    fieldMap.code.input.on('input', function () {
        normalizePersonalCodeInput($(this));
        updateSubmitState();
    });

    form.on('input change', 'input, select', function () {
        updateSubmitState();
        if (warningBox.is(':visible')) {
            clearWarnings();
        }
    });

    fieldMap.name.input.on('blur', function () {
        $(this).data('touched', true);
        validateAndShowInline();
    });
    fieldMap.email.input.on('blur', function () {
        $(this).data('touched', true);
        validateAndShowInline();
    });
    fieldMap.phone.input.on('blur', function () {
        $(this).data('touched', true);
        validateAndShowInline();
    });

    updateSubmitState();

    form.on('submit', function (e) {
        e.preventDefault();
        if (formRunning) return;

        if (!updateSubmitState()) {
            validateAndShowInline();
            return;
        }

        formRunning = true;
        clearWarnings();
        preloader.addClass('preloader-visible');

        const formData = $(this).serializeArray().reduce(function (obj, item) {
            const csrfName = window.CSRFHelper && window.CSRFHelper.getCSRFData ? window.CSRFHelper.getCSRFData().name : 'carbuy_csrf';
            if (item.name === csrfName || item.name === 'csrf_test_name' || item.name === 'csrf_hash' || item.name === 'csrf_name') {
                return obj;
            }
            obj[item.name] = item.value;
            return obj;
        }, {});

        if (typeof formData.phone === 'string') {
            formData.phone = normalizePhone(formData.phone);
        }
        if (typeof formData.income === 'string') {
            const inc = parseIncome(formData.income);
            formData.income = Number.isFinite(inc) ? String(inc) : formData.income;
        }
        if (typeof formData.work_experience === 'string') {
            formData.work_experience = String(formData.work_experience).replace(/\D/g, '');
        }

        csrfSafeAjaxPost(
            '/leasing/submitStep1',
            formData,
            function (response) {
                if (response.success) {
                    const modalCtx = window.CarBuyLeasingModalContext || {};
                    const loanAmount = formData.total_price || modalCtx.loan_amount || '';
                    const pricing = {
                        loan_amount: loanAmount,
                        total_price: loanAmount,
                        vehicle_price: modalCtx.vehicle_price || ''
                    };
                    if (window.CarBuyMetaPixel && typeof window.CarBuyMetaPixel.buildLeasingPricingFromExtra === 'function') {
                        Object.assign(pricing, window.CarBuyMetaPixel.buildLeasingPricingFromExtra(Object.assign({
                            car_id: formData.car_id || modalCtx.car_id || ''
                        }, pricing)));
                    }
                    const trackPayload = Object.assign({
                        applicant_type: 'person',
                        car_id: formData.car_id || modalCtx.car_id || '',
                        form_location: 'leasing_modal_v2',
                        application_ref: response.application_ref || '',
                        application_id: response.application_id || 0
                    }, pricing);
                    const redirectUrl = response.redirect || '/leasing/complete-app';
                    const go = function () {
                        window.location.href = redirectUrl;
                    };
                    if (window.CarBuyAnalytics && typeof window.CarBuyAnalytics.trackLeasingStep1Conversion === 'function') {
                        window.CarBuyAnalytics.trackLeasingStep1Conversion(trackPayload, go);
                        window.setTimeout(go, 1200);
                    } else {
                        go();
                    }
                } else if (response.errors) {
                    warningBox.show();
                    Object.entries(response.errors).forEach(([field, message]) => {
                        markFieldError(field, message);
                    });
                } else if (response.message) {
                    warningBox.show().html('<div class="single-warning-message">' + $('<div>').text(response.message).html() + '</div>');
                }
            },
            function (xhr) {
                if (xhr.status === 403) {
                    warningBox.show().html('<div class="single-warning-message">Pieeja nav atļauta.</div>');
                    return;
                }
                try {
                    const response = xhr.responseJSON || JSON.parse(xhr.responseText || '{}');
                    if (response.errors) {
                        warningBox.show();
                        Object.entries(response.errors).forEach(([field, message]) => {
                            markFieldError(field, message);
                        });
                    } else if (response.message) {
                        warningBox.show().html('<div class="single-warning-message">' + $('<div>').text(response.message).html() + '</div>');
                    } else {
                        warningBox.show().html('<div class="single-warning-message">Kļūda nosūtot pieteikumu. Lūdzu mēģiniet vēlreiz.</div>');
                    }
                } catch (err) {
                    warningBox.show().html('<div class="single-warning-message">Kļūda apstrādājot atbildi. Lūdzu mēģiniet vēlreiz.</div>');
                }
            },
            function () {
                formRunning = false;
                preloader.removeClass('preloader-visible');
            }
        );
    });
});
